import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Clock, Heart, Award } from 'lucide-react';
import Baies from '../../../../assets/images/diet/RR36.jpg';


const SimilarRecipes = () => {
  const recipes = [
    {
      image:Baies,
      title: "Salade de printemps aux fraises",
      type: "RECETTE",
      author: null,
      tags: ["Végétarien", "Végétalien", "Sans lactose", "Sans gluten", "saine et équilibrée", "Low Carb"],
      time: "20 min",
      likes: 1828
    },
    {
      image:Baies,
      title: "Potage de printemps énergisant",
      type: "RECETTE",
      author: {
        name: "Sephi (FOOBY Team)",
        avatar: Baies
      },
      tags: [],
      time: "40 min",
      likes: 1532
    },
    {
      image: Baies,
      title: "Tacos de printemps",
      type: "RECETTE POUR ENFANTS",
      author: null,
      tags: ["Végétarien"],
      time: "30 min",
      likes: 391,
      masterChef: true
    },
    {
      image: Baies,
      title: "Mini-focaccia de printemps",
      type: "RECETTE POUR ENFANTS",
      author: null,
      tags: ["Végétarien", "Végétalien", "Sans lactose"],
      time: "45 min | 3-2,5 h",
      likes: 156,
      masterChef: true
    }
  ];

  return (
    <Container className="my-5">
      <h2 className="text-center mb-4">RECETTES SIMILAIRES</h2>
      <Row>
        {recipes.map((recipe, index) => (
          <Col key={index} md={3} className="mb-4">
            <Card>
              <Card.Img variant="top" src={recipe.image} />
              <Card.Body>
                <Card.Subtitle className="mb-2 text-muted">{recipe.type}</Card.Subtitle>
                {recipe.author && (
                  <div className="d-flex align-items-center mb-2">
                    <img src={recipe.author.avatar} alt={recipe.author.name} className="rounded-circle me-2" style={{width: '30px', height: '30px'}} />
                    <small>de {recipe.author.name}</small>
                  </div>
                )}
                <Card.Title>{recipe.title}</Card.Title>
                {recipe.tags.length > 0 && (
                  <p className="small text-muted">{recipe.tags.join(', ')}</p>
                )}
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <Clock size={16} className="me-1" />
                    <small>{recipe.time}</small>
                  </div>
                  <div className="d-flex align-items-center">
                    <Heart size={16} className="me-1" />
                    <small>{recipe.likes}</small>
                  </div>
                </div>
                {recipe.masterChef && (
                  <div className="mt-2">
                    <Award size={16} className="me-1" />
                    <small>Master Chef</small>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      <div className="text-center mt-4">
        <Button variant="outline-success">VOIR PLUS</Button>
      </div>
    </Container>
  );
};

export default SimilarRecipes;